import reliabilityIndexTranslates from '../section-project/reliability-index-i18n.json';

export default function () {
  return {
    ...reliabilityIndexTranslates,

    main: {
      ru: 'Главная',
      ua: 'Головна'
    },
    aboutBild: {
      ru: 'Про Билд-новостройки',
      ua: 'Про Білд-новобудови'
    },

    h1: {
      ru: 'Привет! Ты наверняка здесь, чтобы выбрать себе квартиру.',
      ua: 'Вітаю! Ти напевно тут, щоб обрати собі квартиру.'
    },
    description: {
      ru: 'Но новостроек так много. В центре, на окраине, недалеко от метро, с подземной парковкой, с детским садом и школой, здесь озеро, а здесь лес. Так много всего, что глаза разбегаются.',
      ua: 'Але новобудов так багато. У центрі, на околиці, недалеко від метро, з підземною парковкою, з дитячим садком і школою, тут озеро, а тут ліс. Так багато всього, що очі розбігаються.'
    },

    h2_1: {
      ru: 'Постой. А что насчёт надёжности новостройки?',
      ua: 'Стривай. А що щодо надійності новобудови?'
    },
    description1_1: {
      ru: 'Это уже более серьёзный вопрос. Точнее их множество.',
      ua: 'Це вже більш серйозне питання. Точніше їх безліч.'
    },
    description1_2: {
      ru: 'Все эти вопросы доставляют только головную боль.',
      ua: 'Всі ці питання доставляють тільки головний біль.'
    },
    listQuestion1: {
      ru: 'Новостройка законна?',
      ua: 'Новобудова законна?'
    },
    listQuestion2: {
      ru: 'Согласованы техусловия?',
      ua: 'Техумови узгоджені?'
    },
    listQuestion3: {
      ru: 'Есть все разрешения?',
      ua: 'Є всі дозволи?'
    },
    listQuestion4: {
      ru: 'Застройщик надёжный?',
      ua: 'Забудовник надійний?'
    },

    h2_2a: {
      ru: 'Поэтому мы в ',
      ua: 'Тому ми в '
    },
    h2_2b: {
      ru: ' создали индекс надёжности новостроек\u00a0*',
      ua: ' створили індекс надійності новобудов\u00a0*'
    },
    description2_1: {
      ru: 'Который поможет тебе выбрать безопасное жильё. В индекс входит\u00a0{{placeholderRU}}, которые позволяют нам оценить надёжность ЖК.',
      ua: 'Який допоможе тобі вибрати безпечне житло. В індекс входить\u00a0{{placeholderUA}}, які дозволяють нам оцінити надійність ЖК.'
    },
    description2_2: {
      ru: 'Мы проверяем назначение и принадлежность земли, реестры запретов, договор и репутацию застройщика. И регулярно обновляем эту информацию.',
      ua: 'Ми перевіряємо призначення і приналежність землі, реєстри заборон, договір і репутацію забудовника. І регулярно оновлюємо цю інформацію.'
    },
    description2_3: {
      ru: '* Индекс надёжности определяется по авторской методике, основанной на анализе данных о новостройках и застройщиках, взятых из открытых источников - реестров, сайтов госорганов, форумов, сайтов застройщиков и новостроек...',
      ua: '* Індекс надійності визначається за авторською методикою, заснованою на аналізі даних про новобудови і забудовників, взятих з відкритих джерел - реєстрів, сайтів держорганів, форумів, сайтів забудовників і новобудов ...'
    },
    description2_4: {
      ru: '** Выводы о надёжности или ненадёжности новостройки, сделанные в результате анализа, являются оценочным суждением авторов.',
      ua: '** Висновки про надійність або ненадійність новобудови, зроблені в результаті аналізу, є оціночним судженням авторів.'
    },
    moreAReliabilityIndex: {
      ru: 'Подробнее о том, как мы считаем индекс',
      ua: 'Детальніше про те, як ми рахуємо індекс'
    },

    h2_3: {
      ru: 'Сам индекс мы представляем в баллах. Давай смотреть на примеры.',
      ua: 'Сам індекс ми представляємо в балах. Давай дивитися на приклади.'
    },
    description3_1: {
      ru: 'Вот здесь у новостройки {{placeholderRU}}. Зеленый щит. Это хороший результат. Это говорит о том, что риски при покупке такого жилья - минимальны, по крайней мере, на момент проведения оценки.',
      ua: 'Ось тут у новобудови {{placeholderUA}}. Зелений щит. Це хороший результат. Це говорить про те, що ризики при покупці такого житла - мінімальні, принаймні, на момент проведення оцінки.'
    },
    description3_2: {
      ru: 'А вот тут уже {{placeholder}}. Красный щит. Рекомендуем трижды подумать и всё перепроверить, прежде чем решиться на покупку таких новостроек.',
      ua: 'А ось тут вже {{placeholder}}. Червоний щит. Рекомендуємо тричі подумати і все перевірити ще раз, перш ніж зважитися на покупку таких новобудов.'
    },
    description3_3: {
      ru: 'Если ЖК отмечен знаком н/а, значит мы еще не успели сделать анализ, но ты всегда можешь его заказать.',
      ua: 'Якщо ЖК відзначений знаком н/а, значить ми ще не встигли зробити аналіз, але ти завжди можеш його замовити.'
    },

    h2_4: {
      ru: 'Правила просты',
      ua: 'Правила прості'
    },
    listRule1: {
      ru: 'Высокий индекс — зеленый щит. Это хороший знак - за такие новостройки, на момент проведения оценки, можно не волноваться.',
      ua: 'Високий індекс — зелений щит. Це хороший знак - за такі новобудови, на момент проведення оцінки, можна не хвилюватися.'
    },
    listRule2: {
      ru: 'Средний индекс — оранжевый щит. Значит, что нужно внимательней посмотреть детали отчёта.',
      ua: 'Середній індекс — помаранчевий щит. Значить, що потрібно уважніше придивитися до деталей звіту.'
    },
    listRule3: {
      ru: 'Низкий индекс — красный щит. Мы рекомендуем изучить отчёт и хорошо подумать, прежде чем приобрести новостройку, где щит индекса красный.',
      ua: 'Низький індекс — червоний щит. Ми рекомендуємо вивчити звіт і добре подумати, перш ніж придбати новобудову, де щит індексу червоний.'
    },
    listRule4: {
      ru: 'Если ЖК отмечен серым щитом и знаком н/а, значит мы еще не успели провести его оценку. Но ты всегда можешь заказать индивидуальный отчёт.',
      ua: 'Якщо ЖК відмічений сірим щитом і знаком н/а, значить ми ще не встигли провести його оцінку. Але ти завжди можеш замовити індивідуальний звіт.'
    },

    h2_5: {
      ru: 'Закажи подробный отчёт',
      ua: 'Замов детальний звіт'
    },
    description5_1: {
      ru: 'Если ты уже выбрал новостройку и хочешь узнать почему её индекс не идеален — закажи подробный отчёт',
      ua: 'Якщо ти вже обрав новобудову і хочеш дізнатися чому її індекс не ідеальний — замовляй детальний звіт'
    },
    h3_5: {
      ru: '5 минут — и он будет у тебя на почте',
      ua: '5 хвилин — і він буде у тебе на пошті'
    },
    description5_2: {
      ru: 'В таких отчётах мы собираем все документы и информацию про ЖК. Каждый параметр оцениваем и если требуется — комментируем. Информацию в отчётах мы обновляем регулярно.',
      ua: 'У таких звітах ми збираємо всі документи і інформацію про ЖК. Кожен параметр оцінюємо і якщо потрібно — коментуємо. Інформацію в звітах ми оновлюємо регулярно.'
    },

    h2_6: {
      ru: 'Ну что, подытожим?',
      ua: 'Ну що, підсумуємо?'
    },
    description6_1: {
      ru: 'Найти надёжные новостройки не так уж и сложно, если знать где искать. Смотри всегда на индекс надёжности и заказывай детальные отчёты, если решился на покупку.',
      ua: 'Знайти надійні новобудови не так вже й складно, якщо знати де шукати. Дивись завжди на індекс надійності і замовляй детальні звіти, якщо зважився на покупку.'
    },
    h3_6: {
      ru: 'Мы поможем тебе найти комфортное и безопасное жильё',
      ua: 'Ми допоможемо тобі знайти комфортне та безпечне житло'
    },
    linkToNext: {
      ru: 'Продолжить',
      ua: 'Продовжити'
    }
  };
}
